// extracted by mini-css-extract-plugin
export var content = "ContactPage-module--content--1u3Ya";
export var message = "ContactPage-module--message--3CoQK";
export var info = "ContactPage-module--info--5HXhY";
export var contactInfo = "ContactPage-module--contactInfo--3opKI";